// src/pages/HomeImpresion.jsx

import React from "react";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import { puedeVerCostosFront } from "../helpers/permisosCostos";
import "../css/homeimpresion.css";

const Icon = ({ type }) => {
  const common = {
    className: "homeimpresion-icon-svg",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
  };

  const strokeProps = {
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  switch (type) {
    case "clienteUsa":
      return (
        <svg {...common}>
          <rect {...strokeProps} x="4" y="3" width="16" height="18" rx="2" />
          <path {...strokeProps} d="M8 7h8" />
          <path {...strokeProps} d="M8 11h4" />
          <circle {...strokeProps} cx="16" cy="15.5" r="2" />
          <path {...strokeProps} d="M13 20a3.5 3.5 0 0 1 6 0" />
        </svg>
      );

    case "clienteCuba":
      return (
        <svg {...common}>
          <rect {...strokeProps} x="3" y="4" width="18" height="16" rx="2" />
          <path {...strokeProps} d="M8 10h8" />
          <path {...strokeProps} d="M8 14h5" />
          <path {...strokeProps} d="m15 15 2 2 4-4" />
        </svg>
      );

    case "productos":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
          <path {...strokeProps} d="m3.3 7 8.7 5 8.7-5" />
          <path {...strokeProps} d="M12 22V12" />
        </svg>
      );

    case "productosLista":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M9 11 4 8l5-3 5 3-5 3Z" />
          <path {...strokeProps} d="m4 13 5 3 5-3" />
          <path {...strokeProps} d="m4 18 5 3 5-3" />
          <path {...strokeProps} d="M17 6h4" />
          <path {...strokeProps} d="M17 11h4" />
          <path {...strokeProps} d="M17 16h4" />
        </svg>
      );

    case "ventas":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M3 3v18h18" />
          <path {...strokeProps} d="M7 15l3-3 3 2 5-7" />
          <path {...strokeProps} d="M18 7h-4" />
          <path {...strokeProps} d="M18 7v4" />
        </svg>
      );

    case "anuladas":
      return (
        <svg {...common}>
          <circle {...strokeProps} cx="12" cy="12" r="9" />
          <path {...strokeProps} d="m15 9-6 6" />
          <path {...strokeProps} d="m9 9 6 6" />
        </svg>
      );

    case "financiero":
      return (
        <svg {...common}>
          <rect {...strokeProps} x="3" y="4" width="18" height="16" rx="2" />
          <path {...strokeProps} d="M7 14h3v3H7z" />
          <path {...strokeProps} d="M14 10h3v7h-3z" />
          <path {...strokeProps} d="M7 8h10" />
        </svg>
      );

    case "pedidos":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
          <path {...strokeProps} d="m3.3 7 8.7 5 8.7-5" />
          <path {...strokeProps} d="M12 22V12" />
          <path {...strokeProps} d="m15 14 2 2 4-4" />
        </svg>
      );

    case "agrupado":
      return (
        <svg {...common}>
          <rect {...strokeProps} x="3" y="3" width="7" height="7" rx="1.5" />
          <rect {...strokeProps} x="14" y="3" width="7" height="7" rx="1.5" />
          <rect {...strokeProps} x="3" y="14" width="7" height="7" rx="1.5" />
          <rect {...strokeProps} x="14" y="14" width="7" height="7" rx="1.5" />
          <path {...strokeProps} d="M10 6.5h4" />
          <path {...strokeProps} d="M6.5 10v4" />
          <path {...strokeProps} d="M17.5 10v4" />
        </svg>
      );

    case "organizar":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M4 7h16" />
          <path {...strokeProps} d="M4 12h16" />
          <path {...strokeProps} d="M4 17h16" />
          <path {...strokeProps} d="M7 7v10" />
          <path {...strokeProps} d="M13 7v10" />
        </svg>
      );

    case "ordenes":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M9 3h6l1 2h3a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3l1-2Z" />
          <path {...strokeProps} d="M9 11h6" />
          <path {...strokeProps} d="M9 15h4" />
          <path {...strokeProps} d="m15 16 2 2 4-4" />
        </svg>
      );

    case "dashboard":
      return (
        <svg {...common}>
          <circle {...strokeProps} cx="12" cy="12" r="9" />
          <path {...strokeProps} d="M12 3v9h9" />
          <path {...strokeProps} d="M12 12 6 18" />
          <path {...strokeProps} d="M12 12h9" />
        </svg>
      );

    default:
      return (
        <svg {...common}>
          <path {...strokeProps} d="M4 4h16v16H4z" />
          <path {...strokeProps} d="M8 8h8" />
          <path {...strokeProps} d="M8 12h8" />
          <path {...strokeProps} d="M8 16h5" />
        </svg>
      );
  }
};

const getRole = () => {
  const token = localStorage.getItem("token") || "";

  try {
    if (!token) return "";

    const decoded = jwt_decode(token);
    return decoded?.usuario?.role || decoded?.user?.role || decoded?.role || "";
  } catch {
    return "";
  }
};

const itemsInformes = [
  {
    to: "/informeclientes",
    label: "Clientes USA",
    description: "Listado y control de clientes compradores.",
    icon: "clienteUsa",
  },
  {
    to: "/informeclientesrecepcion",
    label: "Clientes CUBA",
    description: "Receptores, contactos y direcciones de entrega.",
    icon: "clienteCuba",
  },
  {
    to: "/informeproductos",
    label: "Productos",
    description: "Informe general de productos registrados.",
    icon: "productos",
  },
  {
    to: "/informeproductos1",
    label: "Productos Detalle",
    description: "Detalle operativo y agrupaciones de productos.",
    icon: "productosLista",
  },
  {
    to: "/informeventas",
    label: "Ventas Realizadas",
    description: "Ventas emitidas, pagos, saldos y control comercial.",
    icon: "ventas",
  },
  {
    to: "/informeventasanuladas",
    label: "Ventas Anuladas",
    description: "Control de operaciones anuladas y trazabilidad.",
    icon: "anuladas",
  },
  {
    to: "/informefinancieroventas",
    label: "Financiero",
    description: "Resumen financiero de ventas y medios de pago.",
    icon: "financiero",
  },
  {
    to: "/informerentabilidad",
    label: "Rentabilidad",
    description: "Venta real, costo histórico, rentabilidad y margen por sede.",
    icon: "financiero",
  },
  {
    to: "/informepedidos",
    label: "Pedidos",
    description: "Listado logístico detallado de pedidos.",
    icon: "pedidos",
  },
  {
    to: "/informepedidosagrupado",
    label: "Pedidos Agrupado",
    description: "Vista agrupada por provincia, municipio y producto.",
    icon: "agrupado",
  },
  {
    to: "/informeorganizarpedidos",
    label: "Organizar Pedidos",
    description: "Selección y armado operativo de órdenes.",
    icon: "organizar",
  },
  {
    to: "/informeordenespedido",
    label: "Órdenes Pedidos",
    description: "Consulta y seguimiento de órdenes generadas.",
    icon: "ordenes",
  },
  {
    to: "/informedashboardfinanciero",
    label: "Dashboard Financiero",
    description: "Resumen financiero con gráfica.",
    icon: "dashboard",
  },
  {
    to: "/informecontrolriders",
    label: "Centro de Control 360",
    description: "Alertas, ventas, sedes, saldos y diferencias financieras.",
    icon: "dashboard",
  },
  {
    to: "/informevendedoresventas",
    label: "Ventas Vendedores",
    description: "Resumen ventas por vendedores con gráfica.",
    icon: "ventas",
  },
  {
    to: "/informeseguimientosclientes",
    label: "Seguimiento Clientes",
    description: "Seguimiento de clientes conflictivos.",
    icon: "clienteUsa",
  },
];

const gruposInformes = [
  {
    id: "gestion",
    titulo: "Clientes y Productos",
    descripcion: "Información general de clientes, receptores y productos.",
    className: "grupo-gestion",
    rutas: [
      "/informeclientes",
      "/informeclientesrecepcion",
      "/informeproductos",
      "/informeproductos1",
      "/informeseguimientosclientes",
    ],
  },
  {
    id: "comercial",
    titulo: "Ventas y Finanzas",
    descripcion: "Control comercial, ventas, vendedores y situación financiera.",
    className: "grupo-comercial",
    rutas: [
      "/informeventas",
      "/informeventasanuladas",
      "/informefinancieroventas",
      "/informerentabilidad",
      "/informedashboardfinanciero",
      "/informecontrolriders",
      "/informevendedoresventas",
    ],
  },
  {
    id: "logistica",
    titulo: "Pedidos y Logística",
    descripcion: "Preparación, agrupación y seguimiento de pedidos.",
    className: "grupo-logistica",
    rutas: [
      "/informepedidos",
      "/informepedidosagrupado",
      "/informeorganizarpedidos",
      "/informeordenespedido",
    ],
  },
];

const HomeImpresion = () => {
  const role = getRole();
  const esVendedor = role === "VENDEDOR_ROLE";
  const puedeVerRentabilidad = puedeVerCostosFront();

  const rutasPermitidasVendedor = [
    "/informeclientes",
    "/informeclientesrecepcion",
    "/informeventas",
    "/informefinancieroventas",
    "/informedashboardfinanciero",
  ];

  /*
    Primero aplicamos permisos sensibles.

    Rentabilidad solamente puede verla:
    ROOT_ROLE o ADMIN_ROLE autorizado.

    Andrés, Victoria, Manager y Vendedor
    quedan excluidos por puedeVerCostosFront().
  */
  const itemsSegunPermisos =
    itemsInformes.filter((item) => {
      if (
        item.to.toLowerCase() ===
        "/informerentabilidad"
      ) {
        return puedeVerRentabilidad;
      }

      return true;
    });

  const itemsPermitidos = esVendedor
    ? itemsSegunPermisos.filter((item) =>
        rutasPermitidasVendedor.includes(
          item.to.toLowerCase()
        )
      )
    : itemsSegunPermisos;

  const gruposPermitidos = gruposInformes
    .map((grupo) => ({
      ...grupo,
      items: itemsPermitidos.filter((item) =>
        grupo.rutas.includes(item.to.toLowerCase())
      ),
    }))
    .filter((grupo) => grupo.items.length > 0);

  return (
    <main className="homeimpresion-riders">
      <section className="homeimpresion-hero">
        <div className="homeimpresion-divider" />

        <h1>Informes Varios</h1>

        <p>
          Reportes operativos, comerciales y logísticos para controlar la
          gestión diaria.
        </p>
      </section>

    <div className="homeimpresion-grupos">
      {gruposPermitidos.map((grupo) => (
        <section
          key={grupo.id}
          className={`homeimpresion-grupo ${grupo.className}`}
        >
          <div className="homeimpresion-grupo-header">
            <div>
              <h2>{grupo.titulo}</h2>
              <p>{grupo.descripcion}</p>
            </div>
          </div>

          <div className="homeimpresion-grid">
            {grupo.items.map(({ to, label, description, icon }) => (
              <Link
                key={to}
                to={to}
                className="homeimpresion-card"
              >
                <div className="homeimpresion-icon-box">
                  <Icon type={icon} />
                </div>

                <div className="homeimpresion-card-body">
                  <h2>{label}</h2>
                  <p>{description}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
    </main>
  );
};

export default HomeImpresion;
